import request from '@/utils/request'

// 查询课程列表
export function listCard(query) {
  return request({
    url: '/system/card/list',
    method: 'get',
    params: query
  })
}

// 查询课程列表
export function listCardMyClass(query) {
  return request({
    url: '/system/card/list/myClass',
    method: 'get',
    params: query
  })
}

// 查询 考核课程 列表
export function myClassModeling(query) {
  return request({
    url: '/system/card/list/myClassModeling',
    method: 'get',
    params: query
  })
}

// 查询课程详细
export function getCard(id) {
  return request({
    url: '/system/card/' + id,
    method: 'get'
  })
}
// 查询介绍课程-详细
export function getMyCard(id) {
  return request({
    url: '/system/card/myClass/' + id,
    method: 'get'
  })
}

// 查询考核课程-详细
export function getkhCard(id) {
  return request({
    url: '/system/card/' + id,
    method: 'get'
  })
}

// 新增课程
export function addCard(data) {
  return request({
    url: '/system/card',
    method: 'post',
    data: data
  })
}

// 修改课程
export function updateCard(data) {
  return request({
    url: '/system/card',
    method: 'put',
    data: data
  })
}

// 删除课程
export function delCard(id) {
  return request({
    url: '/system/card/' + id,
    method: 'delete'
  })
}

// 导出课程
export function exportCard(query) {
  return request({
    url: '/system/card/export',
    method: 'get',
    params: query
  })

}
// 报名
export function signUp(data) {
  return request({
    url: '/system/card/signUp',
    method: 'post',
    data: data
  })
}

// 取消报名
export function cancelSignUp(data) {
  return request({
    url: '/system/card/cancalSignUp',
    method: 'post',
    data: data
  })
}

// 1、查询课程方向
export function getClassDirection() {
  return request({
    url: '/data/type/class_direction',
    method: 'get',
  })
}
// 2、查询课程内容
export function getClassContent(data) {
  return request({
    url: '/data/dictCssList',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/myClass/card.js